// routes
import Router from "./routes";
// theme
import ThemeConfig from "./theme";
// components
import firebase from "firebase/app";
import firebaseConfig from "./utils/firebase";
import ScrollToTop from "./components/ScrollToTop";
import { useEffect } from "react";

// =================================================

// 👇 Declaração para o TS não reclamar
declare global {
  interface Window {
    clarity?: (method: "identify" | "set", ...args: any[]) => void;
  }
}

function App() {
  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
  }
  const userData = localStorage.getItem("user");
  useEffect(() => {
    const userData = localStorage.getItem("user");
    if (userData) {
      if (window.clarity) {
        const parsed = JSON.parse(userData);
        const id = parsed?.idUser.toString() || "";

        window.clarity("identify", `user-${id}`);

        window.clarity("set", "role", parsed?.role);
        window.clarity("set", "companyId", parsed?.idCompany);

        window.clarity("set", "email", parsed?.email);
      }
    }
  }, [userData]);

  return (
    <ThemeConfig>
      <ScrollToTop />
      <Router />
    </ThemeConfig>
  );
}

export default App;
